import Footer from "../../../navigation/footerContainer";
import MyPropertiesContainer from "./myPropertiesContainer";


export default function MyWonPropertiesPage() {
    return (
        <>
            <MyPropertiesContainer />
            <Footer />
        
        </>
    )

}